<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <!-- Search -->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search saved searches..."
          [(ngModel)]="searchTerm"
          (keyup.enter)="onSearch(searchTerm)"
        />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end gap-2" data-kt-customer-table-toolbar="base">
        <!-- Bulk Delete Button -->
        <button
          *ngIf="hasSelectedItems"
          type="button"
          class="btn btn-danger"
          (click)="onBulkDelete()"
          [disabled]="isDeleting"
        >
          <i class="ki-duotone ki-trash fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
            <span class="path4"></span>
            <span class="path5"></span>
          </i>
          <span *ngIf="!isDeleting">Delete Selected ({{ selectedIds.size }})</span>
          <span *ngIf="isDeleting">Deleting...</span>
        </button>

        <button
          type="button"
          class="btn btn-dark btn-sm fw-bold d-flex"
          (click)="onSearch(searchTerm)"
        >
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body pt-0">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-3">Loading saved searches...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && savedSearches.length === 0" class="text-center py-10">
      <div class="mb-5">
        <i class="ki-duotone ki-search-list fs-5x text-muted">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
      </div>
      <h3 class="text-gray-600">No Saved Searches Found</h3>
      <p class="text-muted">There are no saved searches to display.</p>
    </div>

    <!-- Table -->
    <div *ngIf="!isLoading && savedSearches.length > 0" class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="w-10px pe-2">
              <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected"
                  (click)="toggleSelectAll()"
                />
              </div>
            </th>
            <th class="min-w-50px text-center">#</th>
            <th class="min-w-150px">Name</th>
            <th class="min-w-120px">Created At</th>
            <th *ngFor="let column of dataColumns" class="min-w-150px">{{ column }}</th>
            <th class="min-w-120px">User</th>
            <th class="min-w-200px text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let search of savedSearches; trackBy: trackByFn; let i = index">
            <td>
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isSelected(search._id)"
                  (change)="toggleSelection(search._id)"
                />
              </div>
            </td>
            <td class="text-center">
              <span class="fw-bold">{{ (paginationInfo.currentPage - 1) * paginationInfo.perPage + i + 1 }}</span>
            </td>
            <td>
              <div class="d-flex flex-column">
                <span class="fw-bold text-gray-800">{{ search.name || 'Unnamed Search' }}</span>
              </div>
            </td>
            <td>
              <span class="fw-semibold">{{ formatDate(search.created_at) }}</span>
            </td>
            <td *ngFor="let column of dataColumns">
              <span class="text-gray-700">{{ getDataValue(search, column) }}</span>
            </td>
            <td>
              <div class="d-flex flex-column">
                <span class="fw-semibold">{{ search.user?.name || 'N/A' }}</span>
                <small class="text-muted" *ngIf="search.user?.country">{{ search.user.country }}</small>
              </div>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                (click)="onSearchStock(search)"
                title="Search Stock"
              >
                <i class="ki-duotone ki-magnifier fs-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                Search
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && savedSearches.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)"
    ></app-pagination>
  </div>
</div>
